document.addEventListener('rebuy:cart.change', event => removeCustomEngravingProduct(event.detail.cart.getItems()));

const removeCustomEngravingProduct = (items) => {
  const engravingProducts = [];

  items.forEach(item => {
    if (!item.properties['_engraving_id']) {
      return;
    }

    const hasEngravingProduct = items.find(cartItem => cartItem.properties['_engraving_id'] && cartItem.key !== item.key && cartItem.properties['_engraving_id'] === item.properties['_engraving_id'])

    if (hasEngravingProduct) {
      engravingProducts.filter(engravingProduct => engravingProduct.properties['_engraving_id'] != item.properties['_engraving_id']);

      return;
    }

    engravingProducts.push(item);
  });

  engravingProducts.forEach(engravingProduct => window.Rebuy.Cart.removeItem(engravingProduct));
}
